import script from "./update.station.modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./update.station.modal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__